module.exports = __webpack_public_path__ + "img/user-5.04990a72.jpg";